import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Typography,
} from "@mui/material";
import { tableCellStyles, tableHeaderStyles } from "../../../../utils/styles";

const UserTabSkeleton: React.FC = () => {
  return (
    <Box >
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Skeleton
          variant="text"
          width={120}
          height={32}
          sx={{ fontWeight: 600 }}
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          <Skeleton
            variant="rectangular"
            width={140}
            height={36}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={140}
            height={36}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Box>

      {/* Table Skeleton */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...tableHeaderStyles, py: 1 }}>
                <Skeleton variant="text" width={60} height={20} />
              </TableCell>
              <TableCell sx={{ ...tableHeaderStyles, py: 1 }}>
                <Skeleton variant="text" width={40} height={20} />
              </TableCell>
              <TableCell sx={{ ...tableHeaderStyles, py: 1 }}>
                <Skeleton variant="text" width={60} height={20} />
              </TableCell>
              <TableCell sx={{ ...tableHeaderStyles, py: 1 }}>
                <Skeleton variant="text" width={50} height={20} />
              </TableCell>
              <TableCell sx={{ ...tableHeaderStyles, py: 1 }}>
                <Skeleton variant="text" width={100} height={20} />
              </TableCell>
              <TableCell
                sx={{
                  ...tableHeaderStyles,
                  py: 1,
                  textAlign: "center",
                  width: "120px",
                }}
              >
                <Skeleton variant="text" width={80} height={20} />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Skeleton Rows */}
            {Array.from({ length: 5 }).map((_, index) => (
              <TableRow key={index}>
                <TableCell sx={{ ...tableCellStyles, py: 0.5 }}>
                  <Skeleton variant="text" width="90%" height={24} />
                </TableCell>
                <TableCell sx={{ ...tableCellStyles, py: 0.5 }}>
                  <Skeleton variant="text" width="70%" height={24} />
                </TableCell>
                <TableCell sx={{ ...tableCellStyles, py: 0.5 }}>
                  <Skeleton variant="text" width="80%" height={24} />
                </TableCell>
                <TableCell sx={{ ...tableCellStyles, py: 0.5 }}>
                  <Skeleton variant="text" width="85%" height={24} />
                </TableCell>
                <TableCell sx={{ ...tableCellStyles, py: 0.5 }}>
                  <Skeleton variant="text" width="95%" height={24} />
                </TableCell>
                <TableCell
                  sx={{
                    ...tableCellStyles,
                    py: 0.5,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    width={50}
                    height={28}
                    sx={{ borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={70}
                    height={28}
                    sx={{ borderRadius: 1 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserTabSkeleton;
